import { useContext, useRef } from "react";
import constants from "../constants";
import AlertContext from "../context/AlertContext";
import useAxiosPrivate from "./useAxiosPrivate";
import useCommonFunctionHooks from "./useCommonFunctionHooks";

const useShareScopeHook = () => {
  const { setIsLoaded, setShowNotify } = useContext(AlertContext);
  const axios = useAxiosPrivate();
  const { getHeaderDetailsForAxios, getCatchBlockDetails } = useCommonFunctionHooks();

  const updateShareScope = async (
    payload,
    onUpdateSuccess,
    from,
    updatedSharedCompanies = []
  ) => {
    try {
      setIsLoaded(true);

      const response = await axios.put(
        `/node/admin/${from}/share-scope`,
        payload,
        getHeaderDetailsForAxios()
      );

      if (response?.data?.resultCode === constants.RESULT_STATUS.SUCCESS) {
        setShowNotify({
          show: true,
          title: "Success!",
          msg: response?.data?.msg ? `${response?.data?.msg}`:"Shared scope updated successfully.",
        });

        onUpdateSuccess?.(payload.topicId || payload.lpId, payload.shareScope, updatedSharedCompanies);
      } else {
        setShowNotify({
          show: true,
          title: "Error!",
          msg:
            response?.data?.msg ||
            "An error occurred while updating shared scope. Please try again.",
        });
      }
    } catch (error) {
      getCatchBlockDetails(error);
    } finally {
      setIsLoaded(false);
    }
  };

  return { updateShareScope };
};

export default useShareScopeHook;
